var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-progress-circular',{staticStyle:{"margin-bottom":"-30px","margin-left":"20px"},attrs:{"color":"primary","indeterminate":"","size":20,"width":3,"value":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }